import { MutationFunction } from '@tanstack/react-query';
import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { IncomeType, IncomeTypeDocument } from './types';
import type { IncomeCategory } from './incomeCategory';

export interface CreateIncomeTypeParams {
  type: string;
  documents?: IncomeTypeDocument[];
  incomeCategory?: IncomeCategory;
  inUse?: boolean;
}

const createIncomeType: MutationFunction<
  IncomeType,
  CreateIncomeTypeParams
> = async (params) => {
  if (isMockServices()) {
    return await mock({
      id: `it-${Date.now()}`,
      type: params.type,
      documents: params.documents ?? [],
      formJson: {},
      incomeCategory: params.incomeCategory ?? null,
      inUse: params.inUse ?? true,
    } as IncomeType);
  }

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<{ success: boolean; data: IncomeType }>(
    '/income-types',
    {
      method: 'POST',
      body: {
        type: params.type,
        ...(params.documents !== undefined && { documents: params.documents }),
        ...(params.incomeCategory !== undefined && {
          incomeCategory: params.incomeCategory,
        }),
        ...(params.inUse !== undefined && { inUse: params.inUse }),
      },
    },
  );

  if (response.data) return response.data.data;
  throw new Error('Failed to create income type');
};

export default createIncomeType;
